export const EXPORT_STEPS = {
  INITIAL_STEP: 0,
  START_EXPORT: 1,
  PREVIEW: 2,
  EXPORT_PROCESSING: 3,
  EXPORT_COMPLETED: 4,
  INITIAL_PACKAGES_STEP: 5,
};

export const DATE_FORMAT = 'DD-MMM-YYYY';

export const STEPS_DESCRIPTION = ['Start Export', 'Preview', 'Export Processing', 'Completed'];

export const TAB_INCLUDE_USER_INDEX = 0;
export const TAB_EXCLUDE_USERS_INDEX = 1;

export const INCLUDED_ACTORS_TABLE_KEY = 'includedActors';
export const EXCLUDED_ACTORS_TABLE_KEY = 'excludedActors';

export const EXPORT_GUIDE = {
  startExportStepDescription: `You can export Application components either from (a.) an existing component List File (CLF), and/or (b.) by selecting items from the list of Available Workflows, and/or (c.) by selecting a date to filter the changed items.
    
    When selecting available workflows, the AutoDiscover feature automatically finds all dependent components of a workflow. The feature is designed to handle one or many workflows.
    
    When selecting from available changed items, the result can be narrowed down to items modified by a specific user instead of taking changes from all users.
    
    Please be aware that selecting multiple components may slow down the export process.`,

  startExportStepPackagesDescription:
    'You can export Application components by selecting from a list of saved package file (s).',

  packagesSteps: {
    a: 'a. Select one or more package file (s).',
    b:
      'b. Click the <strong>Preview</strong> button to see all dependent components of the above selections.',
  },

  steps: {
    a:
      'a. To export from an existing file, click the <strong>browse</strong> button and select a Component List File (*.clf).',
    b:
      'b. To select from the <strong>Available Workflow</strong>, choose at least one workflow from the list and move to the <strong>Workflows to AutoDiscover</strong>.',
    c: 'c. Select a date from which changes to be included to date.',
    d:
      'd. Click the <strong>Preview</strong> button to see all dependent components of the above selections.',
  },

  actorsText:
    'To filter the changed items modified only by a specific person, zoom to select a user. If left blank, all changed items by all users will be included.',

  clickHereText: ` to view and/or modify the list of all changed items that are included by default.
    Note that <strong>Clients</strong> and <strong>Entities Master Setup</strong> are not included by default due to its possibility of high volume.`,

  warning: 'Expect delay while the system is generating result.',

  allowedTypes: ['clf'],

  previewStepInfo:
    'Review the <strong>Application Component Name</strong> generated from the selected components in step one and verify the <strong>Action for Duplicate Item</strong>. Disable the checkbox for item(s) to be excluded from the export process. Click the Export button to start the export process. Click the Check In button to save the Package File in database.',

  cancelInfo: 'Click on the Cancel button to terminate the process.',

  changedItemsModal: {
    excludedItemsDescription: `Clients and Entities Master Setup are not included by default due to its possibility of high
        volume. <strong>Enable the checkbox to include them</strong>.`,

    includedItemsDescription: `All changed items
        below are included by default. <strong>Disable the checkbox to exclude any of them, or select the
        Uncheck All/Check All link to exclude/include all items below</strong>.`,
  },

  completeStepInfo: 'To download the exported file, click the <strong>Download</strong> button.',
};

export const FILE_UPLOAD_ALLOWED_TYPES = ['clf'];

export const STATUSES = {
  PENDING: 'Pending',
  SUCCESS: 'Success',
  COMPLETE: 'Complete',
  FAIL: 'Fail',
  CANCEL: 'Cancelled',
  CHECKED: 'Checked In',
};

export const cancelModalText =
  'By terminating the process, the remaining components will not be Exported. To Export the remaining components, you have to start the process from the beginning.';

export const EXPORT_POLLING_TIME = process.env.NODE_ENV === 'test' ? 0 : 6000;

export const PACKAGES_TABLE_ENTITY_NAME = 'AMC_APP_MIGRATION_CLF';
export const PACKAGES_DETAIL_TABLE_ENTITY_NAME = 'V_AMI_APP_MIGRATION_ITEM';
export const PACKAGES_TABLE_SAVED_SEARCHES_NAME = 'Application Migration Package List';
export const DETAILS_TABLE_SAVED_SEARCHES_NAME = 'Application Migration Package Item';
export const PACKAGES_TABLE_TITLE = 'Package Files';
export const DETAILS_TABLE_TITLE = 'Package Details';
export const PACKAGES_ACTOR_ENTITY_NAME = 'Actor';

export const PACKAGES_EXPORT = 'packages';
export const DEFAULT_EXPORT = 'export';
